import React from 'react';
import styled from 'styled-components/macro';
import { ProductActionButtonsDivProps } from '../types/ProductActionButtonsProps';
import Button from './Button';
import { parseBoolean } from '../utils/parseBoolean';

const UnstyledProductActionButtons: React.FC<ProductActionButtonsDivProps> = ({
  className,
  tried,
  liked,
  onTried,
  onLiked,
  onBuy,
  likebutton,
  buybutton,
  trybutton,
}) => {
  const likeButtonElement = parseBoolean(likebutton?.show, true);
  const buyButtonElement = parseBoolean(buybutton?.show, true);
  const tryButtonElement = parseBoolean(trybutton?.show, true);
  return (
    <div className={'ww-product-action-buttons ' + className}>
      {onTried && tryButtonElement && (
        <Button
          className="ww-action-button-try"
          primary
          solid={tried}
          onClick={onTried}
        >
          {trybutton?.text ? (
            <span>
              {trybutton?.text}&nbsp;{tried ? <i className="icon-ok" /> : ''}
            </span>
          ) : (
            <span>
              'Tried'&nbsp;{tried ? <i className="icon-ok" /> : 'it?'}
            </span>
          )}
        </Button>
      )}
      {onLiked && likeButtonElement && (
        <Button
          className="ww-action-button-like"
          primary
          solid={liked}
          onClick={onLiked}
        >
          {likebutton?.text ? (
            <span>
              {likebutton?.text}&nbsp;
              {liked ? <i className="icon-heart" /> : ''}
            </span>
          ) : (
            <span>
              'Liked'&nbsp;{liked ? <i className="icon-heart" /> : 'it?'}
            </span>
          )}
        </Button>
      )}
      {onBuy && buyButtonElement && (
        <Button
          className="ww-action-button-buy"
          secondary
          solid={tried && liked}
          onClick={onBuy}
        >
          {buybutton?.text ? (
            buybutton.text
          ) : (
            <span>
              'Buy it'&nbsp;
              <i className="icon-basket" />
            </span>
          )}
        </Button>
      )}
    </div>
  );
};

const ProductActionButtons = styled(UnstyledProductActionButtons)`
  display: flex;
  flex-direction: row;
  margin-top: 1em;

  .ww-button {
    flex: 1;
    text-transform: uppercase;
    font-weight: 400;
    padding: 0.5em;
    border-right-style: none;
  }

  .ww-button:last-child {
    border-right-style: solid;
  }
`;

export default ProductActionButtons;
